export default {
  footer: [
    {
      text: 'Privacy Policy',
      link: 'https://www.rsk.co/privacy-policy'
    },
    'Copyright © 2015-2020 IOV Labs. All rights reserved.'
  ]
}
